import * as React from "react";
import { FlowType } from "../../commons/model/FlowType";
import "./FlowConfigurationDescription.scss";
import FullAssessmentDefaultPreview from "../../../resources/images/flows/full-assessment-default-preview.png";
import SmileAssessmentDefaultPreview from "../../../resources/images/flows/smile-assessment-default-preview.png";
import SmileSimulationDefaultPreview from "../../../resources/images/flows/smile-simulation-default-preview.png";
import FullAssessmentDmipPreview from "../../../resources/images/flows/full-assessment-dmip-preview.png";
import SmileAssessmentDmipPreview from "../../../resources/images/flows/smile-assessment-dmip-preview.png";
import SmileSimulationDmipPreview from "../../../resources/images/flows/smile-simulation-dmip-preview.png";
import { FullAssessmentIcon } from "../../commons/components/images/FullAssessmentIcon";
import { SmileAssessmentIcon } from "../../commons/components/images/SmileAssessmentIcon";
import { SmileSimulationIcon } from "../../commons/components/images/SmileSimulationIcon";
import { FlowPreviewBackground } from "../../commons/components/images/FlowPreviewBackground";
import { FlowPreviewBackgroundMobile } from "../../commons/components/images/FlowPreviewBackgroundMobile";

interface FlowConfiguration {
  title: string;
  description: string;
  displayIcon: () => any;
  previewImage: any;
}

const FlowConfigurationDescription = ({
  flowType,
  isDmipPlatform,
}: {
  flowType: FlowType;
  isDmipPlatform: boolean;
}) => {
  let config: FlowConfiguration;

  switch (flowType) {
    case FlowType.FULL_ASSESSMENT:
      config = {
        title: i18n["Page.Settings.Customisation.Flow.Integration.FullAssessment.Title"],
        description:
          i18n["Page.Settings.Customisation.Flow.Integration.FullAssessment.Description"],
        displayIcon: FullAssessmentIcon,
        previewImage: isDmipPlatform ? FullAssessmentDmipPreview : FullAssessmentDefaultPreview,
      };
      break;
    case FlowType.SMILE_ASSESSMENT:
      config = {
        title: i18n["Page.Settings.Customisation.Flow.Integration.SmileAssessment.Title"],
        description:
          i18n["Page.Settings.Customisation.Flow.Integration.SmileAssessment.Description"],
        displayIcon: SmileAssessmentIcon,
        previewImage: isDmipPlatform ? SmileAssessmentDmipPreview : SmileAssessmentDefaultPreview,
      };
      break;
    case FlowType.SMILE_SIMULATION:
      config = {
        title: i18n["Page.Settings.Customisation.Flow.Integration.SmileSimulation.Title"],
        description:
          i18n["Page.Settings.Customisation.Flow.Integration.SmileSimulation.Description"],
        displayIcon: SmileSimulationIcon,
        previewImage: isDmipPlatform ? SmileSimulationDmipPreview : SmileSimulationDefaultPreview,
      };
      break;
    default:
      throw new Error(`Unsupported flow type [${flowType}]`);
  }

  return (
    <div className="flow-description-panel">
      <p className="flow-configuration-title">
        {i18n["Page.Settings.Customisation.Flow.Integration.Page.Configuration.Title"]}
      </p>
      <div className="flex-center flow-description">
        {config.displayIcon()}
        <div className="v-flex">
          <div className="flow-description-title">{config.title}</div>
          <div className="flow-description-content">{config.description}</div>
        </div>
        <div className="flow-preview">
          <img className="flow-preview-image" src={config.previewImage} alt="Flow preview" />
          <div className="flow-preview-background">
            <FlowPreviewBackground></FlowPreviewBackground>
          </div>
          <div className="flow-preview-background-mobile">
            <FlowPreviewBackgroundMobile></FlowPreviewBackgroundMobile>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlowConfigurationDescription;
